import { createContext } from "preact-context";

export const LinkHandlerContext = createContext();


// WEBPACK FOOTER //
// ./components/Contexts.js